import { createSlice } from "@reduxjs/toolkit";

const TicketingPot = createSlice({
  name: "TicketingPot",
  initialState: {
    ticketList: [],
    activePotData: null,
    potSize: 0,
    totalSold: 0,
  },
  reducers: {
    getTicketList: (state, action) => {
      const data = action.payload;

      const ticketList = data
      state.ticketList = ticketList;
    },
   
    setTotalPotSize: (state, action) => {
      state.potSize = action.payload?.currentPotValue;
      state.totalSold = action.payload?.totalTicketsSold;
    },
    setActivePotData: (state, action) => {
      state.activePotData = action.payload;
    },
    ResetPotHistoryDetail: (state, action) => {
      state.ticketList = [];
    },
  },
});
export const {
  getTicketList,
  setTotalPotSize,
  setActivePotData,
} = TicketingPot.actions;
export default TicketingPot.reducer;
